import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=62292e1c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62292e1c"]])

export default __exports__